import React from "react";
import { useHistory } from "react-router-dom";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import { connect } from 'react-redux';
import useServedLocations from "hooks/useServedLocations";
import TypewriterText from "helpers/TypewriterText";
//import WomanHoldingTomatoes from "../../images/images/woman-holding-tomatoes-3213283.jpg";

//import Header, { NavLink, NavLinks, PrimaryLink, LogoLink, NavToggle, DesktopNavLinks } from "../headers/light.js";
//import ResponsiveVideoEmbed from "../../helpers/ResponsiveVideoEmbed.js";

/*const StyledHeader = styled(Header)`
  ${tw`pt-8 max-w-none`}
  ${DesktopNavLinks} ${NavLink}, ${LogoLink} {
    ${tw`text-gray-100 hover:border-gray-300 hover:text-gray-300`}
  }
  ${NavToggle}.closed {
    ${tw`text-gray-100 hover:text-primary-500`}
  }
`;*/
/*
const Image = styled.div(props => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded bg-contain bg-no-repeat bg-center h-full`,
]); */

/*const Container = styled.div`
  ${tw`relative -mx-8 mt-0 bg-center bg-cover`}
  background-image: url(${WomanHoldingTomatoes});
`;
*/

const Container = styled.div(props => [
  `background-image: url(${props.i});`,  
  tw`relative -mx-8 mt-0 bg-center bg-cover`,  
]);


const OpacityOverlay = styled.div`
  ${tw`z-10 absolute inset-0`}
  background: linear-gradient(135deg, rgba(2, 44, 34, 0.95) 0%, rgba(6, 78, 59, 0.8) 55%, rgba(0, 0, 0, 0.45) 100%);
`;

const HeroContainer = tw.div`z-20 relative px-4 sm:px-8 max-w-screen-xl mx-auto`;
const TwoColumn = tw.div`pt-12 pb-32 px-4 flex justify-between items-center flex-col lg:flex-row`;
const LeftColumn = tw.div`flex flex-col items-center lg:block max-w-2xl`;
//const RightColumn = tw.div`w-full sm:w-5/6 lg:w-1/2 mt-16 lg:mt-0 lg:pl-8`;

const Heading = styled.h1`
  ${tw`text-3xl text-center lg:text-left sm:text-4xl lg:text-5xl xl:text-6xl font-black text-gray-600 leading-tight`}
  span {
    ${tw`inline-block mt-2 text-white`}
  }
`;

const SlantedBackground = styled.span`
  ${tw`relative px-6 py-2 font-black inline-block`}
  color: #020617;
  &::before {
    content: "";
    ${tw`absolute inset-0 transform -skew-x-12 -z-10 rounded-sm`}
    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
    box-shadow: 0 4px 15px rgba(217, 119, 6, 0.4);
  }
`;

const Notification = styled.span`
  ${tw`inline-flex items-center my-4 px-4 py-2 rounded-full border text-xs tracking-wider uppercase shadow-sm font-semibold`}
  background-color: rgba(6, 78, 59, 0.6);
  border-color: rgba(6, 78, 59, 0.5);
  color: #fbbf24;
`;

const Notification2 = styled.div`
  ${tw`block my-6 font-medium text-base sm:text-lg max-w-xl leading-relaxed`}
  color: rgba(209, 250, 229, 0.9);
`;

const ActionButton = styled.a`
  ${tw`inline-block text-center mr-4 px-8 py-4 mt-8 text-sm sm:text-base font-bold rounded-lg shadow-md transition-all duration-300 transform focus:outline-none`}
  ${props => props.primary 
    ? `
      background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
      color: #020617 !important;
      &:hover {
        background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
        transform: translateY(-2px);
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
      }
    `
    : `
      background-color: transparent;
      border: 2px solid #34d399;
      color: #f8fafc !important;
      &:hover {
        background-color: rgba(6, 78, 59, 0.4);
        border-color: #6ee7b7;
        transform: translateY(-2px);
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
      }
    `
  }
`;

/*const StyledResponsiveVideoEmbed = styled(ResponsiveVideoEmbed)`
  padding-bottom: 56.25% !important;
  padding-top: 0px !important;
  ${tw`rounded`}
  iframe {
    ${tw`rounded bg-black shadow-xl`}
  }
`;
*/
const BgAsImComponent = (props) => {
  const history = useHistory();
  const { states, loading } = useServedLocations();

  const BackgroundImage = props.BackgroundAsImageData.BackgroundImage;
  const NotificationData = props.BackgroundAsImageData.Notification;
  const HeadingData = props.BackgroundAsImageData.Heading;
  const SlantedBackgroundData = props.BackgroundAsImageData.SlantedBackground;
  const PrimaryActionUrl = props.BackgroundAsImageData.PrimaryActionUrl;
  const Notification2Data = props.BackgroundAsImageData.Notification2;
  const PrimaryActionButtonText = props.BackgroundAsImageData.PrimaryActionButtonText;
  const PrimaryActionUrl2 = props.BackgroundAsImageData.PrimaryActionUrl2;
  const PrimaryActionButtonText2 = props.BackgroundAsImageData.PrimaryActionButtonText2;

   const statesKey = states.map((s) => s.name).join("|");

  return (            
    <Container i={BackgroundImage}>          
      <OpacityOverlay />
      <HeroContainer>
        {/*<StyledHeader links={navLinks} />*/}
        <TwoColumn>
          <LeftColumn>
            <Notification>
              {loading ? (
                NotificationData
              ) : (
                <TypewriterText
                  key={statesKey}
                  phrases={states.length > 0 ? states.map((s) => s.name) : ["Abuja", "Abeokuta"]}
                  prefix="We have now launched operations in "
                  suffix="!!"
                  className="bg-transparent border-none p-0 text-current text-xs tracking-wider uppercase font-semibold shadow-none inline-block align-middle"
                />
              )}
            </Notification>
            <Heading>
              <span>{HeadingData}</span>
              <br />
              <SlantedBackground>{SlantedBackgroundData}</SlantedBackground>                            
              <Notification2>{Notification2Data}</Notification2>
            </Heading>            
            <ActionButton primary href={PrimaryActionUrl}>
                {PrimaryActionButtonText}
            </ActionButton>
            <ActionButton href={PrimaryActionUrl2} onClick={(e) => {
              e.preventDefault();
              history.push(PrimaryActionUrl2);
            }}>
              {PrimaryActionButtonText2}
            </ActionButton>
          </LeftColumn>
          {/*<RightColumn>
            <StyledResponsiveVideoEmbed
              url="//player.vimeo.com/video/374265101?title=0&portrait=0&byline=0&autoplay=0&responsive=1"
              background="transparent"
            />
          </RightColumn>*/}
        </TwoColumn>
      </HeroContainer>
    </Container>
    
  );
};

const BackgroundAsImage = connect((state) => ({
  BackgroundAsImageData: state.BackgroundAsImageData
}))(BgAsImComponent);

export default BackgroundAsImage;